var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"admin-card-title",style:({ fontWeight: 'bold', fontSize: '1.5em', marginBottom: '18px', color: '#000' })},[_vm._v(_vm._s(_vm.title)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }